(function() {
  function trackPickupClick(link) {
    var productId = link.getAttribute('data-product-id') || '';
    var variantId = link.getAttribute('data-variant-id') || '';
    var productTitle = link.getAttribute('data-product-title') || '';
    var payload = {
      event: 'pdp_pickup_click',
      event_category: 'pdp_delivery',
      event_label: 'showroom_pickup',
      pickup_type: 'showroom',
      product_id: productId,
      variant_id: variantId,
      product_title: productTitle,
      page_path: window.location.pathname,
      page_location: window.location.href
    };

    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push(payload);
    }

    if (typeof gtag === 'function') {
      gtag('event', 'pdp_pickup_click', {
        event_category: 'pdp_delivery',
        event_label: 'showroom_pickup',
        product_id: productId,
        variant_id: variantId,
        product_title: productTitle
      });
    }
  }

  function bind(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-pdp-pickup-track]').forEach(function(link) {
      if (link.dataset.pdpPickupTrackBound === '1') return;
      link.dataset.pdpPickupTrackBound = '1';
      link.addEventListener('click', function() {
        trackPickupClick(link);
      });
    });
  }

  function boot() {
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(event) {
    bind(event.target);
  });
})();
